const DOCUMENT = 'SUB_UNIT_MANAGER_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  EDIT: DOCUMENT + 'EDIT',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  DELETE: DOCUMENT + 'DELETE',
  ADD: DOCUMENT + 'ADD',
  CREATE: DOCUMENT + 'CREATE',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  CONVERT_TO_APPLICANT: DOCUMENT + 'CONVERT_TO_APPLICANT',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  delete: data => ({
    type: actions.DELETE,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  create: data => ({
    type: actions.CREATE,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  convertToApplicant: data => ({
    type: actions.CONVERT_TO_APPLICANT,
    payload: data,
  }),
};

export default actions;
